import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldShowBanner)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.b())
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('content'))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('icon')),
            innerHTML: _ctx.displayedIcons.info
          }, null, 10, _hoisted_1),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('text'))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("Перед началом работы пройдите процедуру")) + " ", 1),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToVerification && _ctx.goToVerification(...args))),
              class: _normalizeClass(_ctx.b('highlight'))
            }, _toDisplayString(_ctx.$t("KYC")), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("и добавьте")) + " ", 1),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToSettings && _ctx.goToSettings(...args))),
              class: _normalizeClass(_ctx.b('highlight'))
            }, _toDisplayString(_ctx.$t("реквизиты")), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("своих компаний в избранное")), 1)
          ], 2)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}